
/**
 * 与安卓交互的异步接口封装
 * @param {funName} [string] 必须 方法名
 * @param {json} [obj] json参数，不需要参数，传空字符串
 * @param {fn} [function] 回调函数
 * 例子：
        android_methodCb('getToken', {
            isForceUpdate:false
        }, function(token){
            //token
        })
*/
var androidMethodCb = (function () {
	var cache = {}
	return function (funName, json, callbackFn) {
		if (cache[funName] === undefined) {
			cache[funName] = 0
		}
		cache[funName]++

		var jsonStr = ''
		if (json) {
			jsonStr = JSON.stringify(json)
		}
		if (typeof callbackFn==='function') {
			var fnName = 'g_android_' + funName + cache[funName]
			window[fnName] = callbackFn
			androidJs.doAndroidAction(funName, jsonStr, fnName)
		} else {
			androidJs.doAndroidAction(funName, jsonStr)
		}
	}
})()

export default androidMethodCb



//////////////////
// WEBPACK FOOTER
// ../common-npm/js/android.js
// module id = null
// module chunks = 